// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__AWWdm","list":"MainNavigation_list__F38-1","active":"MainNavigation_active__LZzaI","logoRight":"MainNavigation_logoRight__DsJ7m"};